export default {
  email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  zipcodeJp: /^\d{7}$/,
  phoneNumberJp: /^0([5789]0\d{4}|\d{5})\d{4}$/,
  password: /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/,
  userName: /^[^&'<>]*$/,
  screenName: /^[a-zA-Z0-9_\-.]*$/,
  uuid: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
};
